import { SensorCategoryType, SensorType } from 'src/enums/nginr-type.enum';

export type SensorCategoryFilter = {
  [key in SensorCategoryType]: SensorType[];
};

export const sensorCategoriesOfTypes: SensorCategoryFilter = {
  [SensorCategoryType.OSS]: [
    SensorType.Web_Site,
    SensorType.News_Site,
    SensorType.Blacklist,
    SensorType.Court_Record,
    SensorType.Social_Media,
  ],
  [SensorCategoryType.File_Upload]: [SensorType.Web_Manual, SensorType.CB_Manual],
  [SensorCategoryType.Streaming]: [SensorType.Camera, SensorType.Card_Reader, SensorType.Fence_Node, SensorType.batP],
};
